import _ from 'lodash';

export const selectTrimTitle = state => _.get(state, 'i18n.trimSelectPanel.trimSelectDefault')

export const getNavigationObject = state => state.navigation || '';

export const getEnvironmentObject = state => state.environment || '';

export const getLanguageFromState = state => state.environment.LANG || '';

export const getBrandFromState = state => state.environment.BRAND_NAME || false;

export const getYearFromState = (state) => { //eslint-disable-line
  const offersObject = state.bestOffers.offers;
  return offersObject && offersObject.request ? state.bestOffers.offers.request.year : '';
}

export const getHostFromState = state => state.config.brandPath || '';

export const getVisitorIdFromState = state => state.config.visitorId || '';

export const browserSizeSelector = state => state.browser.mediaType || '';



/** WEBPACK FOOTER **
 ** ./src/redux/selectors/index.js
 **/